module.exports = __webpack_public_path__ + "assets/Illustration.16dfe6f3.png";